import { AuthForm } from "@/components/auth/auth-form"

export default function SignInPage() {
  return (
    <div className="container flex items-center justify-center min-h-[calc(100vh-3.5rem)]">
      <AuthForm />
    </div>
  )
}